import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
const CardShimmer = ({
  width,
  height,
  borderRadius,
  dataTestId,
  md = "3",
  xs = "6",
}: {
  width: string;
  height: string;
  borderRadius: string;
  color?: string;
  dataTestId?: string;
  md?: string;
  xs?: string;
}) => {
  return (
    <Grid
      item
      xs={Number(xs)}
      md={Number(md)}
      data-testid={dataTestId}
      data-tut="summary-inference"
    >
      <Skeleton
        animation="wave"
        width={width}
        height={height}
        sx={{
          borderRadius,
        }}
        variant="rectangular"
      />
    </Grid>
  );
};
export const InferenceCardShimmer = ({
  width,
  height,
  borderRadius,
}: {
  width: string;
  height: string;
  borderRadius: string;
}) => {
  return (
    <Grid
      item
      xs={6}
      md={3}
      lg={3}
      data-testid="inference-shimmer"
      data-tut="summary-inference"
    >
      <Skeleton
        animation="wave"
        width={width}
        height={height}
        sx={{
          borderRadius,
        }}
        variant="rectangular"
      />
    </Grid>
  );
};
export default CardShimmer;
